/* logiq-builder.js — LOGIQ air suspension package builder. Additive 2026-09-13.
   Reads fitment from #logiq-fitment-data (rendered from logiq_fitment metaobjects)
   and globals from #logiq-settings-data. Fires logiq_* events through window.RRWTrack.
   No fitment/pricing matrix is embedded here — data comes from the store. */
(function () {
  'use strict';
  var root = document.querySelector('[data-logiq]');
  if (!root) return;

  function parseJSON(id, fallback) {
    var el = document.getElementById(id);
    if (!el) return fallback;
    try { return JSON.parse(el.textContent); } catch (e) { return fallback; }
  }
  var FITS = parseJSON('logiq-fitment-data', []) || [];
  var CFG = parseJSON('logiq-settings-data', {}) || {};
  if (CFG.accent) root.style.setProperty('--lq-accent', CFG.accent);
  function num(x) { var n = parseFloat(x); return isNaN(n) ? 0 : n; }
  function labor(x) { var n = parseFloat(x); return (isNaN(n) || n <= 0) ? null : n; }
  // component prices arrive as strings from text settings — coerce to numbers so sums don't concatenate
  if (CFG.components) { ['hd2', 'tank', 'remote'].forEach(function (k) { if (CFG.components[k]) CFG.components[k].price = num(CFG.components[k].price); }); }
  CFG.default_manual_labor = labor(CFG.default_manual_labor);
  CFG.default_airiq_labor = labor(CFG.default_airiq_labor);
  if (CFG.compressors) CFG.compressors.forEach(function (c) { c.price = num(c.price); });
  function selectedCompressor() { var list = CFG.compressors || []; return list.filter(function (c) { return c.sku === state.compressor; })[0] || list[0] || null; }
  function compressorSelectorHTML() {
    var list = CFG.compressors || [];
    if (list.length < 2) return '';
    var cur = list.filter(function (c) { return c.sku === state.compressor; })[0] || list[0];
    var h = '<div class="logiq-compsel"><span class="logiq-compsel__lbl">Choose your compressor</span><div class="logiq-choices">';
    list.forEach(function (cc) {
      h += '<button type="button" class="logiq-chip logiq-compchip' + (cc.rec ? ' is-rec' : '') + '" data-comp="' + cc.sku + '" aria-pressed="' + (cc.sku === state.compressor ? 'true' : 'false') + '">'
        + '<span class="logiq-compchip__name">' + (cc.short || cc.label) + (cc.rec ? ' ★' : '') + '</span>'
        + '<span class="logiq-compchip__price">' + money(cc.price) + '</span>'
        + '</button>';
    });
    return h + '</div>' + (cur && cur.note ? '<p class="logiq-compnote">' + cur.note + '</p>' : '') + '</div>';
  }

  function track(name, payload) {
    try { if (window.RRWTrack && window.RRWTrack.custom) window.RRWTrack.custom(name, payload || {}); } catch (e) {}
  }
  function money(n) {
    if (n == null || isNaN(n)) return null;
    return '$' + Number(n).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function el(sel, ctx) { return (ctx || root).querySelector(sel); }
  function els(sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); }
  function clearPulse() { els('.logiq-pulse').forEach(function (e) { e.classList.remove('logiq-pulse'); }); }
  function pulseEls(list) { clearPulse(); Array.prototype.forEach.call(list || [], function (e) { if (e) e.classList.add('logiq-pulse'); }); }

  /* -------------------- fitment expansion -------------------- */
  function brandOf(token) {
    if (/silverado/i.test(token)) return 'Chevrolet';
    if (/sierra/i.test(token)) return 'GMC';
    return null;
  }
  function expandNums(token) {
    var m = token.match(/^(.*?)(\d{3,4}(?:\/\d{3,4})+)(.*)$/);
    if (m) { return m[2].split('/').map(function (n) { return (m[1] + n + m[3]).trim(); }); }
    return [token];
  }
  function cleanModel(t) { return t.replace(/\s*\(.*?\)\s*/g, '').trim(); }

  function servesOf(rec) {
    var makes = String(rec.make || '').split(/\s+\/\s+/).map(function (s) { return s.trim(); }).filter(Boolean);
    var tokens = String(rec.model || '').split(/\s+\/\s+/).map(function (s) { return s.trim(); }).filter(Boolean);
    var out = [];
    tokens.forEach(function (tok) {
      expandNums(cleanModel(tok)).forEach(function (model) {
        var mk = makes.length > 1 ? (brandOf(model) || makes[0]) : makes[0];
        out.push({ make: mk, model: model });
      });
    });
    return out;
  }
  FITS.forEach(function (r) { r._serves = servesOf(r); r._endY = r.end_year || 9999; });

  function recordsFor(year, make, model) {
    return FITS.filter(function (r) {
      if (year < r.start_year || year > r._endY) return false;
      return r._serves.some(function (s) {
        return (!make || s.make === make) && (!model || s.model === model);
      });
    });
  }

  /* -------------------- selector -------------------- */
  var yearSel = el('[data-logiq-year]'), makeSel = el('[data-logiq-make]'), modelSel = el('[data-logiq-model]');
  var makeField = makeSel.closest('.logiq-field'), modelField = modelSel.closest('.logiq-field');
  makeField.classList.add('is-hidden'); modelField.classList.add('is-hidden');
  var qWrap = el('[data-logiq-questions]');
  var state = { year: null, make: null, model: null, record: null, answers: {}, pkg: null, ful: null, calc: null, compressor: null, optTank: true, optRemote: true, optInstall: true };
  state.compressor = ((CFG.compressors || []).filter(function (c) { return c.rec; })[0] || (CFG.compressors || [])[0] || {}).sku || (CFG.components && CFG.components.hd2 ? CFG.components.hd2.sku : '50-42200');

  var maxYear = (new Date().getFullYear()) + 1;
  var minYear = FITS.reduce(function (m, r) { return Math.min(m, r.start_year || m); }, maxYear);
  (function fillYears() {
    var html = '<option value="">Select year</option>';
    for (var y = maxYear; y >= minYear; y--) html += '<option value="' + y + '">' + y + '</option>';
    yearSel.innerHTML = html;
  })();
  setStep(1);
  pulseEls([yearSel]);

  function fillSelect(sel, items, ph) {
    sel.innerHTML = '<option value="">' + ph + '</option>' + items.map(function (i) {
      return '<option value="' + i.replace(/"/g, '&quot;') + '">' + i + '</option>';
    }).join('');
    sel.disabled = items.length === 0;
  }
  function uniq(a) { return a.filter(function (v, i) { return a.indexOf(v) === i; }); }

  yearSel.addEventListener('change', function () {
    state.year = parseInt(this.value, 10) || null;
    state.make = state.model = state.record = null;
    makeSel.value = ''; modelSel.value = ''; modelSel.disabled = true;
    resetDownstream();
    if (!state.year) { makeSel.disabled = true; makeField.classList.add('is-hidden'); modelField.classList.add('is-hidden'); makeSel.innerHTML = '<option value="">Select make</option>'; return; }
    var makes = uniq(recordsFor(state.year, null, null).reduce(function (acc, r) {
      r._serves.forEach(function (s) { if (state.year >= r.start_year && state.year <= r._endY) acc.push(s.make); });
      return acc;
    }, [])).sort();
    fillSelect(makeSel, makes, 'Select make');
    makeField.classList.remove('is-hidden'); modelField.classList.add('is-hidden');
    pulseEls([makeSel]);
    track('logiq_vehicle_year_select', { vehicle_year: String(state.year) });
  });

  makeSel.addEventListener('change', function () {
    state.make = this.value || null;
    state.model = state.record = null;
    modelSel.value = ''; resetDownstream();
    if (!state.make) { modelSel.disabled = true; modelField.classList.add('is-hidden'); modelSel.innerHTML = '<option value="">Select model</option>'; return; }
    var models = uniq(recordsFor(state.year, state.make, null).reduce(function (acc, r) {
      r._serves.forEach(function (s) { if (s.make === state.make) acc.push(s.model); });
      return acc;
    }, [])).sort();
    fillSelect(modelSel, models, 'Select model');
    modelField.classList.remove('is-hidden');
    pulseEls([modelSel]);
    track('logiq_vehicle_make_select', { vehicle_make: state.make });
  });

  modelSel.addEventListener('change', function () {
    state.model = this.value || null; state.record = null; resetDownstream();
    if (!state.model) return;
    track('logiq_vehicle_model_select', { vehicle_model: state.model });
    var cands = recordsFor(state.year, state.make, state.model);
    if (!cands.length) { showUnsupported(); return; }
    state._cands = cands;
    state.answers = {};
    renderQuestions(cands); // reveals questions one at a time; computes results after the last is answered
  });

  function resetDownstream() {
    qWrap.hidden = true; qWrap.innerHTML = '';
    ['[data-logiq-results]', '[data-logiq-fulfillment]', '[data-logiq-review]', '[data-logiq-guides]', '[data-logiq-unsupported]'].forEach(function (s) {
      var n = el(s); if (n) n.hidden = true;
    });
    el('[data-logiq-selerr]').hidden = true;
    state.pkg = state.ful = state.calc = null;
    updateSticky();
  }

  /* -------------------- conditional questions -------------------- */
  function primary(cands) {
    // non-LT base record drives question rendering
    return cands.filter(function (r) { return !/-LT$/i.test(r.kit_sku || ''); })[0] || cands[0];
  }
  function duallyCapable(rec, model) {
    return rec.drw && /(?:F-350|F-450|3500)/i.test(model || '');
  }
  function coversLift(trigger, lift) {
    var t = String(trigger || '').toLowerCase();
    if (lift === '1-3') return /1-3|1"|2"|1–3|1-6/.test(t);
    if (lift === '3-6') return /3-6|3–6|1-6/.test(t);
    return false;
  }
  function liftOptions(cands) {
    var opts = ['stock'], has13 = false, has36 = false;
    cands.forEach(function (r) {
      if (/-LT$/i.test(r.kit_sku || '')) has36 = true;
      (r.spacer_kit || []).forEach(function (s) {
        if (coversLift(s.trigger, '1-3')) has13 = true;
        if (coversLift(s.trigger, '3-6')) has36 = true;
      });
    });
    if (has13) opts.push('1-3');
    if (has36) opts.push('3-6');
    return opts;
  }

  function chipGroup(key, label, options) {
    var html = '<div class="logiq-q"><span>' + label + '</span><div class="logiq-choices">';
    options.forEach(function (o) {
      html += '<button type="button" class="logiq-chip" data-q="' + key + '" data-v="' + o.v + '" aria-pressed="false">' + o.t + '</button>';
    });
    return html + '</div></div>';
  }

  function renderQuestions(cands) {
    var rec = primary(cands), model = state.model, html = '';
    // No pre-selected defaults — the customer must actively choose each option before advancing.
    if (duallyCapable(rec, model)) {
      html += chipGroup('config', 'Rear wheels', [{ v: 'srw', t: 'Single (SRW)' }, { v: 'drw', t: 'Dual (DRW)' }]);
    }
    var lo = liftOptions(cands);
    if (lo.length > 1) {
      html += chipGroup('lift', 'Rear suspension', lo.map(function (o) {
        return { v: o, t: o === 'stock' ? 'Stock' : (o === '1-3' ? 'Lifted 1–3"' : 'Lifted 3–6"') };
      }));
    }
    if ((rec.spacer_kit || []).some(function (s) { return /2wd/i.test(s.trigger || ''); })) {
      html += chipGroup('drivetrain', 'Drivetrain', [{ v: '4wd', t: '4WD' }, { v: '2wd', t: '2WD' }]);
    }
    if (rec.factory_air && rec.factory_air !== 'none') {
      html += chipGroup('factory_air', 'Factory air suspension?', [{ v: 'no', t: 'No' }, { v: 'yes', t: 'Yes' }]);
    }
    if (rec.relocation_kit && /sensor/i.test((rec.relocation_kit.trigger || '') + (rec.relocation_kit.name || ''))) {
      html += chipGroup('sensors', 'Factory rear height sensors / adaptive?', [{ v: 'no', t: 'No' }, { v: 'yes', t: 'Yes' }]);
    }
    if (rec.fuel_tank_restrictions) {
      html += chipGroup('fuel_tank', 'Aftermarket fuel tank?', [{ v: 'no', t: 'No' }, { v: 'yes', t: 'Yes' }]);
    }
    if (/not compatible/i.test(rec.hitch_compatibility || '') && /5th|fifth/i.test(rec.hitch_compatibility || '')) {
      html += chipGroup('hitch', 'Fifth-wheel or gooseneck hitch?', [{ v: 'no', t: 'No' }, { v: 'yes', t: 'Yes' }]);
    }
    if (/aftermarket/i.test(rec.leaf_spring_restrictions || '')) {
      html += chipGroup('leaf', 'Aftermarket leaf springs?', [{ v: 'no', t: 'No' }, { v: 'yes', t: 'Yes' }]);
    }
    qWrap.innerHTML = html;
    qWrap.hidden = html === '';
    // progressive reveal: show one question at a time, next pops up as you answer
    var qEls = els('.logiq-q', qWrap);
    qEls.forEach(function (q, i) { if (i > 0) q.classList.add('is-hidden'); });
    if (qEls.length === 0) { recompute(); }
    else { pulseEls(qEls[0].querySelectorAll('.logiq-chip')); }
    els('.logiq-chip', qWrap).forEach(function (chip) {
      chip.addEventListener('click', function () {
        var k = this.getAttribute('data-q');
        els('.logiq-chip[data-q="' + k + '"]', qWrap).forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
        this.setAttribute('aria-pressed', 'true');
        state.answers[k] = this.getAttribute('data-v');
        var resultsShown = !el('[data-logiq-results]').hidden;
        var next = qWrap.querySelector('.logiq-q.is-hidden');
        if (next && !resultsShown) { next.classList.remove('is-hidden'); pulseEls(next.querySelectorAll('.logiq-chip')); }
        // only compute once EVERY question actually has an answer (not merely revealed)
        var qKeys = els('.logiq-q', qWrap).map(function (q) { var c = q.querySelector('.logiq-chip'); return c && c.getAttribute('data-q'); });
        var allAnswered = qKeys.every(function (kk) { return state.answers[kk] != null; });
        if (resultsShown || allAnswered) { recompute(); }
      });
    });
  }

  /* -------------------- pricing engine -------------------- */
  function resolveRecord(cands, ans) {
    if (cands.length === 1) return cands[0];
    if (ans.lift === '3-6') return cands.filter(function (r) { return /-LT$/i.test(r.kit_sku || ''); })[0] || cands[0];
    return cands.filter(function (r) { return !/-LT$/i.test(r.kit_sku || ''); })[0] || cands[0];
  }

  function compute(cands, ans) {
    var rec = resolveRecord(cands, ans);
    var res = { record: rec, addOns: [], notes: [], unsupported: false, reason: '', priceIssue: false, review: false };

    if (ans.bed === 'cab_chassis' && !rec.cab_chassis) { res.unsupported = true; res.reason = 'This kit does not fit cab & chassis trucks.'; return res; }
    if (ans.fuel_tank === 'yes' && rec.fuel_tank_restrictions) { res.unsupported = true; res.reason = 'This kit is not compatible with aftermarket fuel tanks.'; return res; }
    if (ans.factory_air === 'yes' && rec.factory_air === 'excluded') { res.unsupported = true; res.reason = 'This kit does not fit trucks with factory air suspension.'; return res; }
    if (ans.hitch === 'yes' && /not compatible/i.test(rec.hitch_compatibility || '')) { res.review = true; res.notes.push('Hitch: ' + rec.hitch_compatibility + ' Road Runner will confirm before purchase.'); }
    if (ans.leaf === 'yes' && /aftermarket/i.test(rec.leaf_spring_restrictions || '')) { res.review = true; res.notes.push('Aftermarket leaf springs may affect fit — Road Runner will confirm.'); }

    // DRW hardware
    if (ans.config === 'drw' && rec.drw_hardware) {
      if (rec.drw_hardware.price != null) res.addOns.push(rec.drw_hardware);
      else { res.priceIssue = true; res.review = true; res.notes.push('DRW hardware SKU/price to be confirmed with Road Runner.'); }
    }
    // lift spacer
    if (ans.lift && ans.lift !== 'stock') {
      var sp = (rec.spacer_kit || []).filter(function (s) { return coversLift(s.trigger, ans.lift); })[0];
      if (sp) { if (sp.price != null) res.addOns.push(sp); else res.priceIssue = true; }
      else if (!/-LT$/i.test(rec.kit_sku || '')) { res.notes.push('Selected lift height may require additional hardware — Road Runner will confirm.'); res.review = true; }
    }
    // drivetrain (Ram 3500 2WD)
    if (ans.drivetrain === '2wd') {
      var tw = (rec.spacer_kit || []).filter(function (s) { return /2wd/i.test(s.trigger || ''); })[0];
      if (tw && tw.price != null) res.addOns.push(tw);
    }
    // factory air adapter
    if (ans.factory_air === 'yes' && rec.factory_air === 'adapter-required' && rec.relocation_kit && /air/i.test(rec.relocation_kit.trigger || '')) {
      if (rec.relocation_kit.price != null) res.addOns.push(rec.relocation_kit);
      else res.notes.push('Factory-air adapter (' + rec.relocation_kit.name + ') sourced separately.');
    }
    // height-sensor relocation
    if (ans.sensors === 'yes' && rec.relocation_kit && /sensor/i.test((rec.relocation_kit.trigger || '') + (rec.relocation_kit.name || ''))) {
      if (rec.relocation_kit.price != null) res.addOns.push(rec.relocation_kit);
    }
    if (rec.fitment_status && rec.fitment_status !== 'Verified') { res.review = true; if (rec.confirm_notes) res.notes.push(rec.confirm_notes); }

    // totals
    var addSum = res.addOns.reduce(function (a, x) { return a + (x.price || 0); }, 0);
    var kit = rec.retail_price || 0;
    var c = CFG.components || {};
    var comp = selectedCompressor() || (c.hd2 ? { sku: c.hd2.sku, name: c.hd2.name, price: c.hd2.price, img: c.hd2.img } : { price: 0 });
    res.compressor = comp;
    var airiqSum = (comp.price || 0) + (state.optTank && c.tank ? c.tank.price : 0) + (state.optRemote && c.remote ? c.remote.price : 0);
    res.manualParts = res.priceIssue ? null : (kit + addSum);
    res.airiqParts = res.priceIssue ? null : (kit + addSum + airiqSum);
    res.manualLabor = (rec.manual_install_labor != null) ? rec.manual_install_labor : CFG.default_manual_labor;
    res.airiqLabor = (rec.airiq_install_labor != null) ? rec.airiq_install_labor : CFG.default_airiq_labor;
    res.manualInstalled = (res.manualLabor != null && res.manualParts != null) ? (res.manualParts + res.manualLabor) : null;
    res.airiqInstalled = (res.airiqLabor != null && res.airiqParts != null) ? (res.airiqParts + res.airiqLabor) : null;
    return res;
  }

  /* -------------------- render results -------------------- */
  function vehLabel() {
    var extra = [];
    if (state.answers.config === 'drw') extra.push('Dual Rear Wheel'); else if (state.answers.config === 'srw') extra.push('Single Rear Wheel');
    if (state.answers.lift && state.answers.lift !== 'stock') extra.push('Lifted ' + (state.answers.lift === '1-3' ? '1–3"' : '3–6"'));
    return state.year + ' ' + state.make + ' ' + state.model + (extra.length ? ' · ' + extra.join(' · ') : '');
  }
  function priceRowHTML(lbl, parts, installed, review) {
    var pv = parts == null ? '<span class="val callforprice">Call for Price</span>' : '<span class="val">' + money(parts) + '</span>';
    var head = '<div class="logiq-price-row"><span class="lbl">' + lbl + ' parts package</span>' + pv + '</div>';
    if (installed == null) {
      // labor not set for this vehicle → no firm install price to offer
      return head + '<div class="logiq-line"><span>Installed at Road Runner</span><span class="amt callforprice">Call for Price</span></div>';
    }
    // Install is OPTIONAL — checkbox toggles it right here on the card (owner: "this part isn't optional")
    var on = state.optInstall !== false;
    var labor = (parts != null) ? (installed - parts) : null;
    var laborAmt = (labor != null && labor > 0) ? '+' + money(labor) : money(installed);
    var inst = '<label class="logiq-line logiq-opt' + (on ? '' : ' is-off') + '" data-logiq-opt="installcard">'
      + '<span class="logiq-li"><span class="logiq-opt__txt"><span class="logiq-opt__name">Add professional installation at Road Runner</span>'
      + '<span class="logiq-opt__tgl"><input type="checkbox" class="logiq-opt__cb"' + (on ? ' checked' : '') + ' aria-label="Add professional installation at Road Runner"><span class="logiq-opt__state">' + (on ? 'Included — uncheck for parts only' : 'Not included — check to add install') + '</span></span>'
      + '</span></span><span class="amt logiq-opt__amt">' + laborAmt + '</span></label>';
    var total = '<div class="logiq-rev-total"><span>' + (on ? 'Total installed' : 'Total — parts only') + '</span><span class="amt">' + money(on ? installed : parts) + '</span></div>';
    return head + inst + total;
  }
  function itemsList(items) {
    return items.map(function (i) {
      return '<div class="logiq-line"><span>' + i.name + (i.sku && i.sku.indexOf('in-kit') < 0 && i.sku.indexOf('adapter-6mm') < 0 ? ' <small>' + i.sku + '</small>' : '') + '</span><span class="amt">' + (i.price ? money(i.price) : (i.price === 0 ? 'included' : 'confirm')) + '</span></div>';
    }).join('');
  }
  // Re-render just the two card price blocks (install toggle changes which total shows; parts/installed values are unchanged).
  function refreshCardPrices() {
    var calc = state.calc; if (!calc) return;
    var mp = el('[data-logiq-manual-price]'), ap = el('[data-logiq-airiq-price]');
    if (mp) mp.innerHTML = priceRowHTML('Manual', calc.manualParts, calc.manualInstalled, calc.review);
    if (ap) ap.innerHTML = priceRowHTML('AirIQ', calc.airiqParts, calc.airiqInstalled, calc.review);
    bindInstallToggles();
    if (state.pkg) fulfillmentPrices();
    if (state.pkg && state.ful) renderReview();
    updateSticky();
  }
  function bindInstallToggles() {
    els('[data-logiq-opt="installcard"]').forEach(function (row) {
      var cb = row.querySelector('.logiq-opt__cb');
      if (!cb || cb._lqBound) return;
      cb._lqBound = true;
      row.addEventListener('click', function (e) { e.stopPropagation(); }); // don't let the label click select the card
      cb.addEventListener('change', function () {
        state.optInstall = this.checked;
        track('logiq_option_toggle', { option: 'install', included: this.checked, package_type: state.pkg || 'airiq' });
        refreshCardPrices();
      });
    });
  }

  function renderResults(calc) {
    var rec = calc.record, res = el('[data-logiq-results]');
    el('[data-logiq-vehline]').textContent = vehLabel() + ' · ' + rec.kit_name + ' (' + rec.kit_sku + ', ' + rec.kit_type + ')';

    var c = CFG.components || {};
    var kitImg = (CFG.kit_images && CFG.kit_images[rec.kit_sku]) || '';
    function thumb(u) { return u ? '<img class="logiq-thumb" src="' + u + '" alt="" loading="lazy">' : '<span class="logiq-thumb logiq-thumb--ph"></span>'; }
    function liLine(u, name, sku, amt) { return '<div class="logiq-line"><span class="logiq-li">' + thumb(u) + '<span>' + name + (sku ? ' <small>' + sku + '</small>' : '') + '</span></span><span class="amt">' + amt + '</span></div>'; }
    // Optional, removable line item (boost tank / remote) — checkbox toggles inclusion in price + cart.
    function optLine(key, it, on) {
      return '<div class="logiq-line logiq-opt' + (on ? '' : ' is-off') + '" data-logiq-opt="' + key + '">'
        + '<span class="logiq-li">' + thumb(it.img)
        + '<span class="logiq-opt__txt"><span class="logiq-opt__name">' + it.name + (it.sku ? ' <small>' + it.sku + '</small>' : '') + '</span>'
        + '<label class="logiq-opt__tgl"><input type="checkbox" class="logiq-opt__cb"' + (on ? ' checked' : '') + ' aria-label="Include ' + it.name.replace(/"/g, '') + ' in package"><span class="logiq-opt__state">' + (on ? 'Optional · included — uncheck to remove' : 'Removed — check to add back') + '</span></label>'
        + '</span></span>'
        + '<span class="amt logiq-opt__amt">' + money(it.price) + '</span></div>';
    }
    var kitHero = kitImg ? '<div class="logiq-card__hero"><img src="' + kitImg + '" alt="' + (rec.kit_name || '') + '" loading="lazy"></div>' : '';
    var kitAmt = rec.retail_price ? money(rec.retail_price) : 'confirm';

    var manualBody = kitHero
      + liLine(kitImg, '<b>' + rec.kit_name + '</b>', rec.kit_sku, kitAmt)
      + '<div class="logiq-line"><span class="logiq-li">' + thumb('') + '<span>Manual Inflation kit — air lines + Schrader valves</span></span><span class="amt">included</span></div>'
      + itemsList(calc.addOns)
      + '<ul><li class="logiq-not">No onboard compressor</li><li class="logiq-not">No boost tank</li><li class="logiq-not">No wiring</li><li class="logiq-not">No app or wireless remote</li></ul>'
      + '<p style="font-size:13px;margin:8px 0 0">Adjust pressure manually through the Schrader valves using an external air source.</p>';
    el('[data-logiq-manual-name]').textContent = (CFG.manual_pkg_name || 'Manual Inflation');
    el('[data-logiq-manual-body]').innerHTML = manualBody;
    el('[data-logiq-manual-price]').innerHTML = priceRowHTML('Manual', calc.manualParts, calc.manualInstalled, calc.review);

    var comp = calc.compressor || { name: c.hd2.name, sku: c.hd2.sku, price: c.hd2.price, img: c.hd2.img };
    var twoChan = comp.sku !== '50-41100';
    var airiqBody = kitHero
      + compressorSelectorHTML()
      + liLine(kitImg, '<b>' + rec.kit_name + '</b>', rec.kit_sku, kitAmt)
      + liLine(comp.img, comp.name, comp.sku, money(comp.price))
      + optLine('tank', c.tank, state.optTank)
      + optLine('remote', c.remote, state.optRemote)
      + itemsList(calc.addOns)
      + '<ul><li class="logiq-inc">' + (comp.sku === '50-42200' ? 'Heavy-duty air compressor (33% duty cycle)' : 'Standard-duty air compressor') + '</li><li class="logiq-inc">' + (twoChan ? 'Two-channel — independent driver &amp; passenger adjustment' : 'Single-channel — both air springs adjust together') + '</li><li class="logiq-inc">AirIQ App control' + (state.optRemote ? ' + wireless remote' : '') + '</li></ul>'
      + '<p style="font-size:13px;margin:8px 0 0">Control and monitor your air suspension through the AirIQ App' + (state.optRemote ? ' or wireless remote' : '') + '.</p>';
    el('[data-logiq-airiq-name]').textContent = (CFG.airiq_pkg_name || 'Complete AirIQ');
    el('[data-logiq-airiq-body]').innerHTML = airiqBody;
    els('[data-comp]', el('[data-logiq-airiq-body]')).forEach(function (b) {
      b.addEventListener('click', function (e) { e.stopPropagation(); state.compressor = this.getAttribute('data-comp'); recompute(true); });
    });
    els('[data-logiq-opt]', el('[data-logiq-airiq-body]')).forEach(function (row) {
      row.addEventListener('click', function (e) { e.stopPropagation(); }); // don't let the toggle select the card
      var cb = row.querySelector('.logiq-opt__cb');
      if (cb) cb.addEventListener('change', function () {
        var key = row.getAttribute('data-logiq-opt');
        if (key === 'tank') state.optTank = this.checked; else if (key === 'remote') state.optRemote = this.checked;
        track('logiq_option_toggle', { option: key, included: this.checked, package_type: 'airiq' });
        recompute(true); // re-prices card + Step 3 + review (see recompute)
      });
    });
    el('[data-logiq-airiq-price]').innerHTML = priceRowHTML('AirIQ', calc.airiqParts, calc.airiqInstalled, calc.review);
    bindInstallToggles();

    res.hidden = false;
    // guides
    renderGuides(calc);
    // notes/review banner
    var errBox = el('[data-logiq-selerr]');
    if (calc.notes.length) { errBox.hidden = false; errBox.innerHTML = '<strong>Fitment notes:</strong> ' + calc.notes.join(' '); }
    else errBox.hidden = true;
  }

  function renderGuides(calc) {
    var rec = calc.record, wrap = el('[data-logiq-guides]'), list = el('[data-logiq-guides-list]');
    var links = [];
    if (rec.install_pdf_url) links.push({ u: rec.install_pdf_url, t: rec.kit_name + ' — installation instructions' });
    calc.addOns.forEach(function (a) { if (a.install_pdf) links.push({ u: 'https://prod-da.s3.us-east-2.amazonaws.com/T00494/' + a.install_pdf, t: a.name + ' — instructions' }); });
    list.innerHTML = links.map(function (l) {
      return '<li><a href="' + l.u + '" target="_blank" rel="noopener" data-logiq-track="logiq_install_guide_click">' + l.t + '</a></li>';
    }).join('');
    wrap.hidden = links.length === 0;
  }

  function recompute(noScroll) {
    if (!state._cands) return;
    var calc = compute(state._cands, state.answers);
    state.calc = calc;
    if (calc.unsupported) { showUnsupported(calc.reason); return; }
    el('[data-logiq-unsupported]').hidden = true;
    renderResults(calc);
    if (state.pkg) fulfillmentPrices();            // keep Step 3 prices in sync with compressor/option changes
    if (state.pkg && state.ful) renderReview();    // keep Step 4 review + totals in sync
    if (state.ful) setStep(4); else if (state.pkg) setStep(3); else setStep(2); // stay where the user is
    if (!state.pkg) pulseEls(els('.logiq-select'));
    track('logiq_fitment_complete', { vehicle_year: String(state.year), vehicle_make: state.make, vehicle_model: state.model, item_category: calc.record.kit_sku });
    updateSticky();
    if (!noScroll) scrollToEl('[data-logiq-results]');
  }

  function showUnsupported(reason) {
    resetDownstream();
    var u = el('[data-logiq-unsupported]');
    u.hidden = false;
    if (reason) { var p = u.querySelector('p'); if (p) p.textContent = reason + ' Send us your vehicle information and Road Runner will check the available options.'; }
    track('logiq_unsupported_vehicle', { vehicle_year: String(state.year || ''), vehicle_make: state.make || '', vehicle_model: state.model || '' });
    updateSticky();
  }

  /* -------------------- package + fulfillment selection -------------------- */
  els('[data-logiq-card]').forEach(function (card) {
    var pick = function () {
      var k = card.getAttribute('data-logiq-card');
      selectPackage(k);
    };
    card.addEventListener('click', function (e) { if (e.target.closest('.logiq-select')) return; pick(); });
    card.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(); } });
  });
  els('[data-logiq-select]').forEach(function (b) {
    b.addEventListener('click', function () { selectPackage(this.getAttribute('data-logiq-select')); });
  });
  function setStep(n) { els('.logiq-steps li').forEach(function (li) { var s = parseInt(li.getAttribute('data-step'), 10); li.classList.toggle('is-active', s === n); li.classList.toggle('is-done', s < n); }); }
  function fulfillmentPrices() {
    if (!state.calc) return;
    var it = installedTotal(), pt = partsTotal();
    var ip = el('[data-logiq-ful-price="installed"]'), pp = el('[data-logiq-ful-price="parts"]');
    if (ip) ip.innerHTML = 'Total installed <b>' + (it != null ? money(it) : 'Call for Price') + '</b>';
    if (pp) pp.innerHTML = 'Parts package <b>' + (pt != null ? money(pt) : 'Call for Price') + '</b>';
  }
  function selectPackage(k) {
    state.pkg = k;
    els('[data-logiq-card]').forEach(function (c) {
      var on = c.getAttribute('data-logiq-card') === k;
      c.classList.toggle('is-selected', on); c.classList.toggle('is-dim', !on); c.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    track(k === 'manual' ? 'logiq_manual_select' : 'logiq_airiq_select', { package_type: k });
    el('[data-logiq-fulfillment]').hidden = false;
    fulfillmentPrices();
    setStep(3);
    pulseEls(els('[data-logiq-fulselect]'));
    updateSticky();
    scrollToEl('[data-logiq-fulfillment]');
  }
  track && (function () {
    // view events when cards appear
  })();

  els('[data-logiq-fulcard]').forEach(function (card) {
    card.addEventListener('click', function (e) { if (e.target.closest('[data-logiq-fulselect]')) return; selectFul(card.getAttribute('data-logiq-fulcard')); });
    card.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectFul(card.getAttribute('data-logiq-fulcard')); } });
  });
  els('[data-logiq-fulselect]').forEach(function (b) {
    b.addEventListener('click', function () { selectFul(this.getAttribute('data-logiq-fulselect')); });
  });
  function selectFul(k) {
    if (!state.pkg) { selectPackage('manual'); }
    state.ful = k;
    if (k === 'installed') state.optInstall = true; // always start with install included when they pick Installed
    els('[data-logiq-fulcard]').forEach(function (c) {
      var on = c.getAttribute('data-logiq-fulcard') === k;
      c.classList.toggle('is-selected', on); c.classList.toggle('is-dim', !on); c.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    setStep(4);
    clearPulse();
    track(k === 'installed' ? 'logiq_installed_select' : 'logiq_parts_package_select', { fulfillment_method: k, package_type: state.pkg });
    renderReview();
    updateSticky();
    scrollToEl('[data-logiq-review]');
  }

  /* -------------------- review + routing -------------------- */
  function currentItems() {
    var calc = state.calc, rec = calc.record, items = [{ name: rec.kit_name, sku: rec.kit_sku, price: rec.retail_price }];
    if (state.pkg === 'airiq') {
      var c = CFG.components; var comp = calc.compressor || c.hd2;
      items.push({ name: comp.name, sku: comp.sku, price: comp.price });
      if (state.optTank && c.tank) items.push(c.tank);
      if (state.optRemote && c.remote) items.push(c.remote);
    }
    calc.addOns.forEach(function (a) { if (a.price != null && a.price > 0) items.push({ name: a.name, sku: a.sku, price: a.price }); });
    return items;
  }
  function partsTotal() { return state.pkg === 'airiq' ? state.calc.airiqParts : state.calc.manualParts; }
  function installedTotal() { return state.pkg === 'airiq' ? state.calc.airiqInstalled : state.calc.manualInstalled; }
  function partsCheckout() {
    var vmap = CFG.variant_map || {}, items = currentItems(), lineItems = [];
    var props = {
      'Vehicle': vehLabel(),
      'Package': (state.pkg === 'airiq' ? (CFG.airiq_pkg_name || 'Complete AirIQ') : (CFG.manual_pkg_name || 'Manual Inflation')),
      'Fitment ID': (state.calc.record.id || ''),
      'Fitment status': (state.calc.record.fitment_status || ''),
      'Note': 'Road Runner reviews final fitment before shipment'
    };
    if (state.answers.config) props['Rear wheels'] = state.answers.config === 'drw' ? 'Dual (DRW)' : 'Single (SRW)';
    if (state.answers.lift && state.answers.lift !== 'stock') props['Rear lift'] = state.answers.lift === '1-3' ? '1-3 in' : '3-6 in';
    items.forEach(function (it) { var vid = vmap[it.sku]; if (vid) lineItems.push({ id: Number(vid), quantity: 1, properties: props }); });
    if (!lineItems.length) { if (CFG.quote_url) window.open(CFG.quote_url, '_blank', 'noopener'); return; }
    track('logiq_parts_checkout', { package_type: state.pkg, fulfillment_method: 'parts' });
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: lineItems }) })
      .then(function (r) { return r.json(); })
      .then(function () { window.location.href = '/cart'; })
      .catch(function () { if (CFG.quote_url) window.open(CFG.quote_url, '_blank', 'noopener'); });
  }

  function buildSummary() {
    var items = currentItems(), lines = [];
    lines.push('LOGIQ ' + (state.pkg === 'airiq' ? (CFG.airiq_pkg_name || 'Complete AirIQ') : (CFG.manual_pkg_name || 'Manual Inflation')) + ' — ' + (state.ful === 'installed' ? 'Installed at Road Runner' : 'Shipped to me — no install'));
    lines.push('Vehicle: ' + vehLabel());
    lines.push('Kit: ' + state.calc.record.kit_name + ' (' + state.calc.record.kit_sku + ', ' + state.calc.record.kit_type + ')');
    lines.push('');
    items.forEach(function (i) { lines.push('  • ' + i.name + ' [' + i.sku + '] ' + (i.price != null ? money(i.price) : '')); });
    lines.push('');
    lines.push('Parts package: ' + (partsTotal() != null ? money(partsTotal()) : 'Call for Price'));
    if (state.ful === 'installed') {
      var sLab = state.pkg === 'airiq' ? state.calc.airiqLabor : state.calc.manualLabor;
      if (state.optInstall !== false) {
        if (sLab != null) lines.push('Installation labor: ' + money(sLab));
        lines.push('Installed total: ' + (installedTotal() != null ? money(installedTotal()) : 'Call for Price (labor confirmed by Road Runner)'));
      } else {
        lines.push('Installation labor: removed — self-install');
        lines.push('Total (parts only, no install): ' + (partsTotal() != null ? money(partsTotal()) : 'Call for Price'));
      }
    }
    lines.push('Fitment status: ' + state.calc.record.fitment_status + (state.calc.review ? ' — Road Runner will review before purchase/install.' : ''));
    return lines.join('\n');
  }

  function renderReview() {
    var rv = el('[data-logiq-review]'), body = el('[data-logiq-review-body]'), items = currentItems();
    var html = '<div class="logiq-line"><span><b>Your truck</b></span><span class="amt">' + vehLabel() + '</span></div>'
      + '<div class="logiq-line"><span><b>Your package</b></span><span class="amt">' + (state.pkg === 'airiq' ? (CFG.airiq_pkg_name || 'Complete AirIQ') : (CFG.manual_pkg_name || 'Manual Inflation')) + ' · ' + (state.ful === 'installed' ? 'Installed at Road Runner' : 'Shipped to me — no install') + '</span></div>';
    items.forEach(function (i) { html += '<div class="logiq-line"><span>' + i.name + ' <small>' + i.sku + '</small></span><span class="amt">' + (i.price != null ? money(i.price) : 'confirm') + '</span></div>'; });
    var pt = partsTotal(), it = installedTotal();
    html += '<div class="logiq-rev-total"><span>Parts price</span><span class="amt">' + (pt != null ? money(pt) : 'Call for Price') + '</span></div>';
    if (state.ful === 'installed') {
      var lab = state.pkg === 'airiq' ? state.calc.airiqLabor : state.calc.manualLabor;
      var instOn = state.optInstall !== false;
      if (lab != null) {
        // labor is a real number → make it a removable line (owner: "make labor its own line")
        html += '<div class="logiq-line logiq-opt' + (instOn ? '' : ' is-off') + '" data-logiq-opt="install">'
          + '<span class="logiq-li"><span class="logiq-opt__txt"><span class="logiq-opt__name">Professional installation (labor)</span>'
          + '<label class="logiq-opt__tgl"><input type="checkbox" class="logiq-opt__cb"' + (instOn ? ' checked' : '') + ' aria-label="Include professional installation labor"><span class="logiq-opt__state">' + (instOn ? 'Included — uncheck to remove install' : 'Removed — you (or your shop) install it') + '</span></label>'
          + '</span></span><span class="amt logiq-opt__amt">' + money(lab) + '</span></div>';
        var total = instOn ? it : pt; // labor removed → parts-only price
        html += '<div class="logiq-rev-total"><span>' + (instOn ? 'Total installed' : 'Total — parts only (no install)') + '</span><span class="amt">' + (total != null ? money(total) : 'Call for Price') + '</span></div>';
      } else {
        html += '<div class="logiq-line"><span>Installation labor</span><span class="amt">Call for Price</span></div>';
        html += '<div class="logiq-rev-total"><span>Total installed</span><span class="amt">' + (it != null ? money(it) : 'Call for Price') + '</span></div>';
      }
    }
    if (state.calc.notes.length) html += '<p class="logiq-fineprint"><strong>Fitment notes:</strong> ' + state.calc.notes.join(' ') + '</p>';
    body.innerHTML = html;
    var instCb = body.querySelector('[data-logiq-opt="install"] .logiq-opt__cb');
    if (instCb) instCb.addEventListener('change', function () {
      state.optInstall = this.checked;
      track('logiq_option_toggle', { option: 'install', included: this.checked, package_type: state.pkg });
      renderReview();
    });
    el('[data-logiq-summary]').textContent = buildSummary();

    var cta = el('[data-logiq-review-cta]'), q = CFG.quote_url || '';
    var confirmed = el('[data-logiq-confirm]');
    function ctaHTML() {
      var disabled = confirmed && !confirmed.checked;
      var lock = disabled ? ' is-locked' : '';
      if (state.ful === 'installed' && state.optInstall !== false) {
        return '<button type="button" class="logiq-btn logiq-btn--primary' + lock + '" ' + (disabled ? 'data-block="1"' : 'data-logiq-sched') + ' data-fallback="' + (CFG.scheduler_url || q || '') + '" data-logiq-track="logiq_schedule_click">Schedule My Installation</button>'
          + '<a class="logiq-btn logiq-btn--ghost" href="tel:' + (CFG.phone_tel || '') + '" data-logiq-track="logiq_call_click">Call ' + (CFG.phone || '') + '</a>';
      }
      // installed but labor removed → it's a parts-only order, fall through to the Add-to-Cart flow
      var canCart = CFG.variant_map && Object.keys(CFG.variant_map).length;
      var partsBtn = canCart
        ? '<button type="button" class="logiq-btn logiq-btn--primary' + lock + '" ' + (disabled ? 'data-block="1"' : 'data-logiq-parts') + '>Add Parts Package to Cart</button>'
        : '<a class="logiq-btn logiq-btn--primary' + lock + '" ' + (disabled ? 'aria-disabled="true" data-block="1"' : '') + ' href="' + (q || '#') + '" target="_blank" rel="noopener" data-logiq-track="logiq_parts_checkout">Get My Parts Package</a>';
      return partsBtn + '<a class="logiq-btn logiq-btn--ghost" href="' + (CFG.financing_url || '/pages/purchaseoptions') + '" data-logiq-track="logiq_financing_click">Payment Options</a>';
    }
    cta.innerHTML = ctaHTML();
    if (confirmed) confirmed.onchange = function () {
      var lbl = el('.logiq-confirm'); if (lbl) lbl.classList.toggle('is-checked', confirmed.checked);
      cta.innerHTML = ctaHTML(); bindCTA();
    };
    bindCTA();
    function bindCTA() {
      els('[data-block="1"]', cta).forEach(function (a) {
        a.addEventListener('click', function (e) {
          e.preventDefault();
          var c = el('.logiq-confirm');
          if (c) {
            c.scrollIntoView({ block: 'center', behavior: 'smooth' });
            c.classList.remove('logiq-flash'); void c.offsetWidth; c.classList.add('logiq-flash');
            setTimeout(function () { c.classList.remove('logiq-flash'); }, 1600);
          }
          if (confirmed) confirmed.focus();
        });
      });
      var sched = el('[data-logiq-sched]', cta);
      if (sched) sched.addEventListener('click', function () {
        var fb = this.getAttribute('data-fallback') || CFG.scheduler_url || CFG.quote_url || '';
        try { if (typeof window.sm_w_scheduler_open === 'function') { window.sm_w_scheduler_open(); return; } } catch (err) {}
        if (fb) window.open(fb, '_blank', 'noopener');
      });
      var parts = el('[data-logiq-parts]', cta);
      if (parts) parts.addEventListener('click', partsCheckout);
    }
    rv.hidden = false;
    track('logiq_package_review', { package_type: state.pkg, fulfillment_method: state.ful });
  }

  /* -------------------- unsupported / fitment request -------------------- */
  var fr = el('[data-logiq-fitment-request]');
  if (fr) fr.addEventListener('click', function (e) {
    if (CFG.quote_url) { this.href = CFG.quote_url; this.target = '_blank'; }
    else { e.preventDefault(); location.href = 'tel:' + (CFG.phone_tel || ''); }
  });

  /* -------------------- mobile sticky bar -------------------- */
  var sticky = el('[data-logiq-sticky]');
  function updateSticky() {
    if (!sticky) return;
    var html = '';
    if (state.record || state.calc) {
      if (!state.pkg) {
        html = '<button type="button" data-jump="[data-logiq-card=manual]">Manual</button><button type="button" data-jump="[data-logiq-card=airiq]">AirIQ</button>';
      } else if (!state.ful) {
        html = '<button type="button" data-fulq="installed">Installed</button><button type="button" data-fulq="parts">Parts</button>';
      } else {
        html = '<a href="tel:' + (CFG.phone_tel || '') + '" data-logiq-track="logiq_call_click">Call</a><button type="button" class="is-primary" data-jump="[data-logiq-review]">Continue</button>';
      }
    }
    if (html) { sticky.innerHTML = html; sticky.setAttribute('data-open', ''); }
    else { sticky.removeAttribute('data-open'); sticky.innerHTML = ''; }
    els('[data-jump]', sticky).forEach(function (b) { b.addEventListener('click', function () { var t = el(this.getAttribute('data-jump')); if (t) { if (t.hasAttribute('data-logiq-card')) selectPackage(t.getAttribute('data-logiq-card')); else scrollToEl(this.getAttribute('data-jump')); } }); });
    els('[data-fulq]', sticky).forEach(function (b) { b.addEventListener('click', function () { selectFul(this.getAttribute('data-fulq')); }); });
  }

  /* -------------------- utilities: build btn, scroll, delegated tracking -------------------- */
  els('[data-logiq-build]').forEach(function (b) { b.addEventListener('click', function () { scrollToEl('#logiq-selector'); yearSel.focus(); }); });
  function scrollToEl(sel) { var t = el(sel); if (t) t.scrollIntoView({ behavior: (matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'), block: 'start' }); }

  /* -------- deep-link prefill: ?year=&make=&model= (from the promo banner picker) -------- */
  (function prefillFromURL() {
    try {
      var p = new URLSearchParams(location.search);
      var y = p.get('year'), mk = p.get('make'), md = p.get('model');
      if (!y) return;
      function setAndFire(sel, val) {
        if (!val) return false;
        sel.value = val;
        if (sel.value !== val) return false;       // option not present → covered? bail
        sel.dispatchEvent(new Event('change'));
        return true;
      }
      if (!setAndFire(yearSel, y)) return;
      if (mk) { if (setAndFire(makeSel, mk) && md) setAndFire(modelSel, md); }
      scrollToEl('#logiq-selector');
    } catch (e) {}
  })();
  root.addEventListener('click', function (e) {
    var t = e.target.closest('[data-logiq-track]'); if (t) track(t.getAttribute('data-logiq-track'), {});
  });

  /* -------------------- hero video: MP4 → worker R2 reel (like homepage) → IG embed -------------------- */
  var hero = el('[data-logiq-hero]');
  function pauseAllVideos(except) { els('[data-logiq-video]').forEach(function (v) { if (v !== except) try { v.pause(); } catch (e) {} }); }
  function wireVideo() {
    var video = el('[data-logiq-video]'); if (!video) return;
    var soundBtn = el('[data-logiq-sound]'), soundLbl = el('[data-logiq-sound-label]'), pp = el('[data-logiq-playpause]');
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) {
        if (en.isIntersecting) { video.play().then(function () { track('logiq_hero_video_play', {}); }).catch(function () {}); }
        else video.pause();
      });
    }, { threshold: 0.4 });
    io.observe(video);
    video.addEventListener('play', function () { pauseAllYT(); });
    if (soundBtn) soundBtn.addEventListener('click', function () {
      video.muted = !video.muted;
      this.setAttribute('aria-pressed', String(!video.muted));
      soundLbl.textContent = video.muted ? 'Tap for sound' : 'Sound on';
      if (video.paused) video.play().catch(function () {});
      if (!video.muted) track('logiq_hero_sound_enabled', {});
    });
    if (pp) pp.addEventListener('click', function () { if (video.paused) { video.play(); this.textContent = '❚❚'; } else { video.pause(); this.textContent = '►'; } });
  }
  function makeVideo(src, poster) {
    if (!hero) return;
    hero.classList.remove('is-ig', 'is-loading');
    hero.innerHTML = '<video data-logiq-video playsinline muted loop preload="metadata"' + (poster ? ' poster="' + poster + '"' : '') + ' aria-label="Road Runner LOGIQ install reel"><source src="' + src + '" type="video/mp4"></video>'
      + '<button type="button" class="logiq-hero__sound" data-logiq-sound aria-pressed="false"><span data-logiq-sound-label>Tap for sound</span></button>'
      + '<div class="logiq-hero__vcontrols"><button type="button" data-logiq-playpause aria-label="Pause video">❚❚</button></div>';
    wireVideo();
  }
  function makeIG() {
    if (!hero) return;
    hero.classList.add('is-ig'); hero.classList.remove('is-loading');
    var ig = hero.getAttribute('data-ig-url') || 'https://www.instagram.com/reel/Dcy-Vl5PNfM/';
    hero.innerHTML = '<blockquote class="instagram-media" data-instgrm-permalink="' + ig + '" data-instgrm-version="14" style="max-width:420px;width:100%;min-width:280px;margin:0;background:#fff;"></blockquote>'
      + '<a class="logiq-hero__igbtn" href="' + ig + '" target="_blank" rel="noopener" data-logiq-track="logiq_hero_video_play">▶ Watch the install on Instagram</a>';
    var proc = function () { try { if (window.instgrm && window.instgrm.Embeds) window.instgrm.Embeds.process(); } catch (e) {} };
    if (window.instgrm && window.instgrm.Embeds) proc();
    else { var s = document.createElement('script'); s.src = 'https://www.instagram.com/embed.js'; s.async = true; s.onload = proc; document.body.appendChild(s); }
    setTimeout(proc, 1800);
  }
  function pauseHeroYT() { var f = el('[data-logiq-ytframe]'); if (f) try { f.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*'); } catch (e) {} }
  function makeYouTube(id) {
    if (!hero) return;
    hero.classList.remove('is-ig', 'is-loading');
    hero.innerHTML = '<iframe data-logiq-ytframe src="https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&mute=1&loop=1&playlist=' + id + '&controls=0&modestbranding=1&rel=0&playsinline=1&enablejsapi=1" title="Road Runner LOGIQ install" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen loading="eager"></iframe>'
      + '<button type="button" class="logiq-hero__sound" data-logiq-ytsound aria-pressed="false"><span data-logiq-sound-label>Tap for sound</span></button>';
    var f = el('[data-logiq-ytframe]'), sb = el('[data-logiq-ytsound]'), lbl = el('[data-logiq-sound-label]'), on = false;
    if (sb) sb.addEventListener('click', function () {
      on = !on;
      try { f.contentWindow.postMessage('{"event":"command","func":"' + (on ? 'unMute' : 'mute') + '","args":""}', '*'); } catch (e) {}
      lbl.textContent = on ? 'Sound on' : 'Tap for sound';
      sb.setAttribute('aria-pressed', String(on));
      if (on) track('logiq_hero_sound_enabled', {});
    });
    track('logiq_hero_video_play', {});
  }
  if (hero) {
    var _yt = hero.getAttribute('data-youtube'), _mp4 = hero.getAttribute('data-mp4'), _code = hero.getAttribute('data-reel-code'),
        _worker = (hero.getAttribute('data-worker') || '').replace(/\/$/, ''), _poster = hero.getAttribute('data-poster');
    if (_yt) { makeYouTube(_yt); }
    else if (_mp4) { makeVideo(_mp4, _poster); }
    else if (_code && _worker) {
      fetch(_worker + '/posts.json').then(function (r) { return r.json(); }).then(function (d) {
        var id = d && d.by_code && d.by_code[_code];
        var p = id && d.by_id && d.by_id[id];
        if (p && p.src) { makeVideo(_worker + '/' + p.src, _poster || (p.poster ? _worker + '/' + p.poster : '')); }
        else { makeIG(); }
      }).catch(makeIG);
    } else { makeIG(); }
  }

  /* -------------------- youtube facades -------------------- */
  function pauseAllYT(except) {
    els('[data-logiq-yt]').forEach(function (yt) {
      if (yt === except) return;
      var f = yt.querySelector('iframe'); if (f) { yt.removeChild(f); yt.classList.remove('is-playing'); }
    });
  }
  els('[data-logiq-yt]').forEach(function (yt) {
    function load() {
      if (yt.querySelector('iframe')) return;
      pauseAllYT(yt); pauseAllVideos(); pauseHeroYT();
      var id = yt.getAttribute('data-logiq-yt');
      var f = document.createElement('iframe');
      f.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0';
      f.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';
      f.allowFullscreen = true; f.title = yt.getAttribute('aria-label') || 'LOGIQ video';
      yt.appendChild(f); yt.classList.add('is-playing');
      track('logiq_education_video_play', { video_id: id });
    }
    yt.addEventListener('click', load);
    yt.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); load(); } });
  });

})();
